export enum ActivityType {
  Vehicle = 'VEHICLE',
  Bicycle = 'BICYCLE',
  OnFoot = 'ON_FOOT',
  Running = 'RUNNING',
  Still = 'STILL',
  Tilting = 'TILTING',
  Walking = 'WALKING',
  Unknown = 'UNKNOWN',
}
